import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';

/**
 * Page "formulaire de contact" des référentiels KTV_EXTERNAL.
 * L'utilisateur arrive ici après l'auto-login (compte générique) et la récupération de la simulation.
 */
@Component({
	selector: 'app-contact-externe',
	templateUrl: './contact-externe.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./contact-externe.component.less']
})
export class ContactExterneComponent implements OnInit {
	textes: any = null;
	globalTxt: any = null;

	constructor(public app: AppComponent) {
	}

	ngOnInit(): void {
		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the page texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;
				});
		});
	}
}
